var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"mb-2 font-regular ml-n1"},[_vm._v("Dashboards")]),_vm._v(" "),(
      _vm.userObj.role === 'collection-officer' ||
        _vm.userObj.role === 'review-officer' ||
        _vm.userObj.role === 'loan-supervisor'
    )?_c('loan-stat'):(_vm.can('dashboard'))?_c('dashboard-stat'):_c('div',{staticClass:"card p-4"},[_c('p',{staticClass:"mb-0"},[_vm._v("You do not have access to dashboard statistics.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }